export default {debug: process.env.NODE_ENV==='development'};



/** WEBPACK FOOTER **
 ** ./src/options.js
 **/